import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useRoleContext } from '../hooks/useRoleContext';
import usePermissions from '../hooks/usePermissions';

const ProtectedPermissionRoute = ({ requiredPermission, redirectPath = '/unauthorized' }: any) => {
  const { role } = useRoleContext();
  const { hasPermission } = usePermissions();

  if (hasPermission(requiredPermission, role)) {
    return <Outlet />; // Render the child routes
  } else {
    return <Navigate to={redirectPath} replace />;
  }
};

export default ProtectedPermissionRoute;
